import { render, staticRenderFns } from "./regionDialog.vue?vue&type=template&id=93587176&scoped=true&"
import script from "./regionDialog.vue?vue&type=script&lang=js&"
export * from "./regionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93587176",
  null
  
)

export default component.exports